import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import toast from 'react-hot-toast';

const InvoicePage = () => {
  const { bookingId } = useParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Simulate API call to fetch booking data
    setTimeout(() => {
      setLoading(false);
    }, 1000);
  }, [bookingId]);

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto mb-4"></div>
          <p className="text-gray-600">Loading invoice...</p>
        </div>
      </div>
    );
  }

  const randomNumber = Math.floor(Math.random() * 90000) + 10000;
  const randomRN = `JS-${randomNumber}-${new Date().getFullYear()}${String(new Date().getMonth() + 1).padStart(2, '0')}`;

  // Mock invoice data
  const invoice = {
    invoiceNumber: randomRN,
    issueDate: new Date().toISOString(),
    dueDate: new Date(Date.now() + 30 * 24 * 60 * 60 * 1000).toISOString(),
    billingAddress: {
      name: 'John Doe',
      address: '123 Main Street',
      city: 'New York',
      state: 'NY',
      zipCode: '10001',
      country: 'United States'
    },
    passenger: {
      name: 'John Doe',
      email: 'john.doe@example.com',
      phone: '+1 (555) 123-4567'
    },
    bookingReference: bookingId || 'ABC123',
    flights: [
      {
        flightNumber: 'JS 1234',
        route: 'JFK → LAX',
        date: '2024-03-20',
        time: '08:30 - 11:45',
        class: 'Economy',
        price: 450.00
      }
    ],
    summary: {
      subtotal: 450.00,
      taxes: 67.50,
      fees: 32.50,
      total: 550.00
    },
    payment: {
      method: 'Credit Card',
      cardType: 'Visa',
      lastFour: '1234',
      transactionId: 'TXN-789456123',
      paymentDate: new Date().toLocaleDateString()
    }
  };

  const handleEmailInvoice = () => {
    toast.info('Email functionality would be implemented here');
  };

  const handleDownloadPDF = () => {
    toast.info('PDF download functionality would be implemented here');
  };

  const handlePrint = () => {
    window.print();
  };

  return (
    <div className="min-h-screen bg-jet-gray-50 py-8">
      <div className="w-[86%] mx-auto sm:px-6 lg:px-8">
        {/* Action Buttons */}
        <div className="flex justify-between items-center mb-6 print:hidden">
          <button
            onClick={() => navigate(-1)}
            className="flex items-center text-jet-gray-600 hover:text-jet-gray-900 transition-colors"
          >
            <svg className="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 19l-7-7 7-7"></path>
            </svg>
            Back
          </button>

          <div className="flex space-x-3">
            <button
              onClick={handleEmailInvoice}
              className="flex items-center px-4 py-2 border border-jet-gray-300 rounded-md text-jet-gray-700 hover:bg-jet-gray-50 transition-colors"
            >
              <svg className="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"></path>
              </svg>
              Email
            </button>
            <button
              onClick={handleDownloadPDF}
              className="flex items-center px-4 py-2 border border-jet-gray-300 rounded-md text-jet-gray-700 hover:bg-jet-gray-50 transition-colors"
            >
              <svg className="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 10v6m0 0l-3-3m3 3l3-3m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"></path>
              </svg>
              Download PDF
            </button>
            <button
              onClick={handlePrint}
              className="flex items-center px-4 py-2 bg-jet-yellow hover:bg-jet-yellow-hover text-jet-gray-900 font-medium rounded-md transition-colors"
            >
              <svg className="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17 17h2a2 2 0 002-2v-4a2 2 0 00-2-2H5a2 2 0 00-2 2v4a2 2 0 002 2h2m2 4h6a2 2 0 002-2v-4a2 2 0 00-2-2H9a2 2 0 00-2 2v4a2 2 0 002 2zm8-12V5a2 2 0 00-2-2H9a2 2 0 00-2 2v4h10z"></path>
              </svg>
              Print
            </button>
          </div>
        </div>

        {/* Invoice */}
        <div className="bg-white rounded-lg shadow-sm p-8">
          {/* Header */}
          <div className="flex justify-between items-start mb-8">
            <div>
              <div className="flex items-center mb-4">
                <div className="w-12 h-12 bg-jet-yellow rounded-lg flex items-center justify-center mr-4">
                  <svg className="w-8 h-8 text-jet-gray-900" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 19l9 2-9-18-9 18 9-2zm0 0v-8"></path>
                  </svg>
                </div>
                <div>
                  <h1 className="text-2xl font-bold text-jet-gray-900">JetScanner</h1>
                  <p className="text-jet-gray-600">Flight Booking Invoice</p>
                </div>
              </div>

              <div className="text-sm text-jet-gray-600">
                <p>JetScanner Inc.</p>
                <p>123 Aviation Blvd</p>
                <p>New York, NY 10001</p>
                <p>Phone: +1 (800) JET-SCANNER</p>
                <p>Email: billing@jetscanner360.com</p>
              </div>
            </div>

            <div className="text-right">
              <h2 className="text-3xl font-bold text-jet-gray-900 mb-2">INVOICE</h2>
              <div className="text-sm space-y-1">
                <p><span className="font-medium">Invoice #:</span> {invoice.invoiceNumber}</p>
                <p><span className="font-medium">Issue Date:</span> {new Date(invoice.issueDate).toLocaleDateString()}</p>
                <p><span className="font-medium">Due Date:</span> {new Date(invoice.dueDate).toLocaleDateString()}</p>
                <p className="mt-3">
                  <span className="inline-block bg-green-100 text-green-800 text-xs px-2 py-1 rounded-full font-medium">
                    PAID
                  </span>
                </p>
              </div>
            </div>
          </div>

          {/* Billing Information */}
          <div className="grid md:grid-cols-2 gap-8 mb-8">
            <div>
              <h3 className="font-semibold text-jet-gray-900 mb-3">Bill To:</h3>
              <div className="text-sm text-jet-gray-700 space-y-1">
                <p className="font-medium">{invoice.billingAddress.name}</p>
                <p>{invoice.billingAddress.address}</p>
                <p>{invoice.billingAddress.city}, {invoice.billingAddress.state} {invoice.billingAddress.zipCode}</p>
                <p>{invoice.billingAddress.country}</p>
              </div>
            </div>

            <div>
              <h3 className="font-semibold text-jet-gray-900 mb-3">Passenger Details:</h3>
              <div className="text-sm text-jet-gray-700 space-y-1">
                <p className="font-medium">{invoice.passenger.name}</p>
                <p>{invoice.passenger.email}</p>
                <p>{invoice.passenger.phone}</p>
                <p className="mt-2"><span className="font-medium">Booking Ref:</span> {invoice.bookingReference}</p>
              </div>
            </div>
          </div>

          {/* Flight Details */}
          <div className="mb-8">
            <h3 className="font-semibold text-jet-gray-900 mb-4">Flight Details</h3>
            <div className="overflow-x-auto">
              <table className="w-full border border-jet-gray-200">
                <thead className="bg-jet-gray-50">
                  <tr>
                    <th className="px-4 py-3 text-left text-xs font-medium text-jet-gray-500 tracking-wider border-b">Flight</th>
                    <th className="px-4 py-3 text-left text-xs font-medium text-jet-gray-500 tracking-wider border-b">Route</th>
                    <th className="px-4 py-3 text-left text-xs font-medium text-jet-gray-500 tracking-wider border-b">Date & Time</th>
                    <th className="px-4 py-3 text-left text-xs font-medium text-jet-gray-500 tracking-wider border-b">Class</th>
                    <th className="px-4 py-3 text-right text-xs font-medium text-jet-gray-500 tracking-wider border-b">Price</th>
                  </tr>
                </thead>
                <tbody>
                  {invoice.flights.map((flight, index) => (
                    <tr key={index}>
                      <td className="px-4 py-3 text-sm text-jet-gray-900 border-b">{flight.flightNumber}</td>
                      <td className="px-4 py-3 text-sm text-jet-gray-900 border-b">{flight.route}</td>
                      <td className="px-4 py-3 text-sm text-jet-gray-900 border-b">
                        <div>{new Date(flight.date).toLocaleDateString()}</div>
                        <div className="text-jet-gray-600">{flight.time}</div>
                      </td>
                      <td className="px-4 py-3 text-sm text-jet-gray-900 border-b">{flight.class}</td>
                      <td className="px-4 py-3 text-sm text-jet-gray-900 border-b text-right">${flight.price.toFixed(2)}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>

          {/* Cost Breakdown */}
          <div className="flex justify-end mb-8">
            <div className="w-80">
              <div className="space-y-2 text-sm">
                <div className="flex justify-between">
                  <span className="text-jet-gray-600">Subtotal:</span>
                  <span className="text-jet-gray-900">${invoice.summary.subtotal.toFixed(2)}</span>
                </div>
                <div className="flex justify-between">
                  <span className="text-jet-gray-600">Taxes & Fees:</span>
                  <span className="text-jet-gray-900">${(invoice.summary.taxes + invoice.summary.fees).toFixed(2)}</span>
                </div>
                <div className="border-t border-jet-gray-200 pt-2">
                  <div className="flex justify-between font-semibold text-lg">
                    <span className="text-jet-gray-900">Total:</span>
                    <span className="text-jet-gray-900">${invoice.summary.total.toFixed(2)}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Payment Information */}
          <div className="border-t border-jet-gray-200 pt-6 mb-8">
            <h3 className="font-semibold text-jet-gray-900 mb-3">Payment Information</h3>
            <div className="grid md:grid-cols-2 gap-6 text-sm">
              <div>
                <p><span className="font-medium text-jet-gray-700">Payment Method:</span> {invoice.payment.method}</p>
                <p><span className="font-medium text-jet-gray-700">Card Type:</span> {invoice.payment.cardType} ending in {invoice.payment.lastFour}</p>
              </div>
              <div>
                <p><span className="font-medium text-jet-gray-700">Transaction ID:</span> {invoice.payment.transactionId}</p>
                <p><span className="font-medium text-jet-gray-700">Payment Date:</span> {invoice.payment.paymentDate}</p>
              </div>
            </div>
          </div>

          {/* Terms & Conditions */}
          <div className="border-t border-jet-gray-200 pt-6 text-xs text-jet-gray-600">
            <h4 className="font-medium text-jet-gray-900 mb-2">Terms & Conditions:</h4>
            <ul className="space-y-1 list-disc list-inside">
              <li>This invoice is generated electronically and is valid without signature.</li>
              <li>All flights are subject to airline terms and conditions.</li>
              <li>Cancellation and refund policies apply as per booking terms.</li>
              <li>For support, contact us at support@jetscanner360.com or +1 (800) JET-SCANNER.</li>
            </ul>
          </div>

          {/* Footer */}
          <div className="text-center mt-8 pt-6 border-t border-jet-gray-200 text-sm text-jet-gray-500">
            <p>Thank you for choosing JetScanner for your travel needs!</p>
            <p className="mt-1">Visit us at www.jetscanner360.com</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default InvoicePage;